import ActivateCardLanding from '../../../banking/components/cards/ActivateCardLanding';

const ActivateCardLandingScreen = () => {
    return <ActivateCardLanding />;
};

export default ActivateCardLandingScreen;
